import AppConstants from '../config/app.constants';

let LogService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/logs`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/logs/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let recentActivity = (branchId, entryType) => {
        return $http
            .get(AppConstants.api + `/logs/recent`, {
                params: {
                    branchId, entryType
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getLogInfo = (entryType, userId) => {
        return $http
            .get(AppConstants.api + `/logs/get-log-info`, {
                params: {entryType, userId}
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        get,
        recentActivity,
        getLogInfo
    };
};

LogService.$inject = ['$http', '$q'];

export default LogService;


// WEBPACK FOOTER //
// ./client/app/services/log.service.js